import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const CLEANERS = [
  {
    icon: "🧹",
    title: "Nettoyage & Entretien",
    color: "#2d9b5c",
    bg: "rgba(45,155,92,.08)",
    border: "rgba(45,155,92,.2)",
    desc: "Nettoyage professionnel de bureaux, immeubles, résidences, copropriétés, parkings et espaces industriels. Contrats journaliers ou ponctuels.",
    services: ["Bureaux & Open spaces", "Résidences & Appartements", "Copropriétés & Immeubles", "Espaces industriels", "Nettoyage après travaux", "Nettoyage de vitres"],
  },
  {
    icon: "🏊",
    title: "Piscines",
    color: "#0ea5e9",
    bg: "rgba(14,165,233,.08)",
    border: "rgba(14,165,233,.2)",
    desc: "Entretien complet de piscines : traitement de l'eau, nettoyage des parois, vérification des équipements, maintenance préventive.",
    services: ["Traitement chimique de l'eau", "Nettoyage fond & parois", "Vérification filtration", "Maintenance équipements", "Mise en hivernage", "Remise en service"],
  },
  {
    icon: "❄️",
    title: "Climatisation",
    color: "#6366f1",
    bg: "rgba(99,102,241,.08)",
    border: "rgba(99,102,241,.2)",
    desc: "Installation, entretien et maintenance de systèmes de climatisation pour particuliers et entreprises. Économisez sur vos consommations énergétiques.",
    services: ["Installation split systems", "Entretien préventif", "Nettoyage filtres & grilles", "Recharge en gaz frigorigène", "Dépannage urgence", "Maintenance contrat"],
  },
  {
    icon: "🐛",
    title: "Nuisibles 3D",
    color: "#dc2626",
    bg: "rgba(220,38,38,.08)",
    border: "rgba(220,38,38,.2)",
    desc: "Traitement 3D : Désinfection, Désinsectisation, Dératisation. Produits homologués, sans danger pour votre famille et vos animaux.",
    services: ["Désinfection générale", "Désinsectisation (cafards, moustiques)", "Dératisation", "Traitement punaises de lit", "Traitement termites", "Contrats préventifs"],
  },
];

const TECHNO = [
  {
    icon: "📱",
    title: "Applications Mobiles",
    color: "#f97316",
    bg: "rgba(249,115,22,.08)",
    border: "rgba(249,115,22,.2)",
    desc: "Développement d'applications iOS et Android natives et cross-platform. De l'idée au déploiement sur les stores.",
    services: ["Apps iOS & Android", "React Native / Flutter", "UI/UX Design", "Intégration APIs", "Maintenance & mises à jour", "App Store Optimization"],
  },
  {
    icon: "🌐",
    title: "Sites & Applications Web",
    color: "#3b6bff",
    bg: "rgba(59,107,255,.08)",
    border: "rgba(59,107,255,.2)",
    desc: "Création de sites vitrines, e-commerce, plateformes SaaS et applications web sur mesure. Technologies modernes et performantes.",
    services: ["Sites vitrines", "E-commerce", "Plateformes SaaS", "Applications React/Next.js", "API REST & GraphQL", "Hébergement & domaine"],
  },
  {
    icon: "🔒",
    title: "Cybersécurité",
    color: "#dc2626",
    bg: "rgba(220,38,38,.08)",
    border: "rgba(220,38,38,.2)",
    desc: "Audit, protection et sécurisation de vos systèmes d'information. Conformité RGPD et bonnes pratiques de sécurité.",
    services: ["Audit de sécurité", "Tests de pénétration", "Protection DDoS", "Pare-feu & VPN", "Formation sécurité", "Conformité RGPD"],
  },
  {
    icon: "💻",
    title: "Équipement IT",
    color: "#8b5cf6",
    bg: "rgba(139,92,246,.08)",
    border: "rgba(139,92,246,.2)",
    desc: "Vente et installation d'équipements informatiques neufs et reconditionnés. Réseau, postes de travail, serveurs.",
    services: ["Ordinateurs & Laptops", "Équipements réseau", "Serveurs & NAS", "Imprimantes & Scanners", "Installation & Configuration", "Support & Maintenance"],
  },
  {
    icon: "🤖",
    title: "Formation & IA",
    color: "#0ea5e9",
    bg: "rgba(14,165,233,.08)",
    border: "rgba(14,165,233,.2)",
    desc: "Formations en intelligence artificielle, développement web, cybersécurité et outils digitaux pour vos équipes.",
    services: ["Formation IA & Machine Learning", "Formation développement web", "Formation cybersécurité", "Ateliers outils digitaux", "Coaching startup tech", "E-learning sur mesure"],
  },
  {
    icon: "☁️",
    title: "Cloud & Infrastructure",
    color: "#2d9b5c",
    bg: "rgba(45,155,92,.08)",
    border: "rgba(45,155,92,.2)",
    desc: "Migration cloud, gestion d'infrastructure AWS/GCP/Azure, DevOps et automatisation de vos pipelines de déploiement.",
    services: ["Migration cloud", "AWS / GCP / Azure", "Docker & Kubernetes", "CI/CD Pipeline", "Monitoring & alertes", "Sauvegarde automatique"],
  },
];

const PROCESSUS = [
  { n: "01", title: "Prise de contact", desc: "Vous nous contactez via formulaire, téléphone ou WhatsApp. Réponse sous 2h." },
  { n: "02", title: "Analyse des besoins", desc: "Un consultant dédié analyse votre situation et vos objectifs en détail." },
  { n: "03", title: "Proposition & devis", desc: "Nous vous soumettons une proposition sur mesure avec devis détaillé gratuit." },
  { n: "04", title: "Validation", desc: "Vous validez le devis et nous planifions ensemble la date d'intervention." },
  { n: "05", title: "Réalisation", desc: "Notre équipe intervient avec professionnalisme selon le cahier des charges défini." },
  { n: "06", title: "Suivi & satisfaction", desc: "Nous assurons un suivi post-intervention et garantissons votre satisfaction." },
];

function ServiceCard({ item, index, visible }) {
  return (
    <div className="card" style={{
      padding: "28px",
      opacity: visible ? 1 : 0,
      transform: visible ? "translateY(0)" : "translateY(30px)",
      transition: `all .5s ease ${index * .1}s`,
    }}>
      <div style={{ ...sty.cardIcon, background: item.bg, border: `1.5px solid ${item.border}` }}>
        <span style={{ fontSize: "24px" }}>{item.icon}</span>
      </div>
      <h3 style={{ fontSize: "17px", fontWeight: 700, color: "#0a2540", margin: "16px 0 10px" }}>{item.title}</h3>
      <p style={{ fontSize: "13px", color: "#4a5a6a", lineHeight: 1.7, marginBottom: "16px" }}>{item.desc}</p>
      <ul style={{ listStyle: "none" }}>
        {item.services.map(sv => (
          <li key={sv} style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "12px", color: "#4a5a6a", marginBottom: "6px" }}>
            <span style={{ color: item.color, fontWeight: 700 }}>→</span>{sv}
          </li>
        ))}
      </ul>
    </div>
  );
}

function useInView() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.1 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return [ref, visible];
}

export default function Services() {
  const [tab, setTab] = useState("cleaners");
  const [heroRef, heroV] = useInView();
  const [cardsRef, cardsV] = useInView();
  const [procRef, procV] = useInView();

  const cards = tab === "cleaners" ? CLEANERS : TECHNO;

  return (
    <div style={{ paddingTop: "72px" }}>

      {/* ─── Hero ─── */}
      <section style={sty.hero} ref={heroRef}>
        <div style={sty.heroBg} />
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <div style={{ opacity: heroV ? 1 : 0, transform: heroV ? "translateY(0)" : "translateY(30px)", transition: "all .7s ease" }}>
            <span className="section-tag">Ce que nous faisons</span>
            <h1 style={sty.heroTitle}>Nos <span style={{ color: "#c9a227" }}>services</span></h1>
            <p style={sty.heroSub}>
              Deux entités spécialisées, une gamme complète de services professionnels pour répondre à tous vos besoins
              en Côte d'Ivoire et en Afrique de l'Ouest.
            </p>
          </div>
        </div>
      </section>

      {/* ─── Tab switcher ─── */}
      <section style={{ background: "#f8f9fc", padding: "60px 0 0" }} ref={cardsRef}>
        <div className="container">
          <div className="text-center" style={{ marginBottom: "40px" }}>
            <h2 className="section-title">Choisissez votre <span>domaine</span></h2>
          </div>
          <div style={sty.tabs}>
            <button onClick={() => setTab("cleaners")} style={{ ...sty.tab, ...(tab === "cleaners" ? sty.tabActive : {}) }}>
              <span style={sty.tabDot(tab === "cleaners" ? "#2d9b5c" : "#aaa")} />
              PurePro Cleaners — Nettoyage & Entretien
            </button>
            <button onClick={() => setTab("techno")} style={{ ...sty.tab, ...(tab === "techno" ? sty.tabActiveOrange : {}) }}>
              <span style={sty.tabDot(tab === "techno" ? "#f97316" : "#aaa")} />
              PurePro Technologie — Digital & IT
            </button>
          </div>
        </div>
      </section>

      {/* ─── Service Cards ─── */}
      <section style={{ background: "#f8f9fc", padding: "40px 0 80px" }}>
        <div className="container">
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: "24px" }}>
            {cards.map((item, i) => (
              <ServiceCard key={item.title} item={item} index={i} visible={cardsV} />
            ))}
          </div>
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <Link to="/devis" className="btn btn-primary" style={{ fontSize: "15px", padding: "14px 32px" }}>
              Demander un devis gratuit →
            </Link>
          </div>
        </div>
      </section>

      {/* ─── Processus ─── */}
      <section className="section" ref={procRef}>
        <div className="container">
          <div className="text-center" style={{ marginBottom: "56px", opacity: procV ? 1 : 0, transition: "all .6s ease" }}>
            <span className="section-tag">Comment ça marche</span>
            <h2 className="section-title">Notre processus <span>d'intervention</span></h2>
            <p className="section-sub" style={{ margin: "0 auto" }}>
              Un processus simple, transparent et efficace pour vous garantir la meilleure expérience.
            </p>
          </div>
          <div className="grid-3" style={{ gap: "28px" }}>
            {PROCESSUS.map((p, i) => (
              <div key={p.n} style={{
                ...sty.procCard,
                opacity: procV ? 1 : 0,
                transform: procV ? "translateY(0)" : "translateY(30px)",
                transition: `all .5s ease ${i * .1}s`,
              }}>
                <div style={sty.procNum}>{p.n}</div>
                <h3 style={sty.procTitle}>{p.title}</h3>
                <p style={sty.procDesc}>{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── Urgences ─── */}
      <section style={{ background: "linear-gradient(135deg, #0a2540, #1e3a5f)", padding: "60px 0" }}>
        <div className="container text-center">
          <div style={{ fontSize: "40px", marginBottom: "16px" }}>🆘</div>
          <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: "32px", color: "#fff", marginBottom: "12px" }}>
            Service d'urgence <span style={{ color: "#c9a227" }}>24h/24 – 7j/7</span>
          </h2>
          <p style={{ color: "rgba(255,255,255,.65)", fontSize: "16px", marginBottom: "28px" }}>
            Pour les interventions urgentes (dératisation, fuite, panne), nous sommes disponibles à toute heure.
          </p>
          <a href="tel:+2250575496457" className="btn btn-primary" style={{ fontSize: "16px", padding: "14px 36px" }}>
            📞 +225 05 75 49 64 57
          </a>
        </div>
      </section>

    </div>
  );
}

const sty = {
  hero: { background: "linear-gradient(135deg, #0a2540 0%, #1e3a5f 100%)", padding: "80px 0", position: "relative", overflow: "hidden" },
  heroBg: { position: "absolute", inset: 0, background: "radial-gradient(ellipse at 80% 50%, rgba(201,162,39,.08), transparent 60%)" },
  heroTitle: { fontFamily: "'Playfair Display',serif", fontSize: "clamp(36px,5vw,56px)", fontWeight: 700, color: "#fff", lineHeight: 1.2, margin: "16px 0 20px" },
  heroSub: { fontSize: "17px", color: "rgba(255,255,255,.7)", lineHeight: 1.8, maxWidth: "580px" },
  tabs: { display: "flex", gap: "16px", justifyContent: "center", flexWrap: "wrap", marginBottom: "0" },
  tab: { display: "flex", alignItems: "center", gap: "10px", padding: "14px 28px", borderRadius: "12px", border: "2px solid #d8e0e8", background: "#fff", fontSize: "14px", fontWeight: 600, color: "#4a5a6a", cursor: "pointer", transition: "all .2s" },
  tabActive: { background: "rgba(45,155,92,.06)", borderColor: "#2d9b5c", color: "#2d9b5c" },
  tabActiveOrange: { background: "rgba(249,115,22,.06)", borderColor: "#f97316", color: "#f97316" },
  tabDot: (color) => ({ width: "10px", height: "10px", borderRadius: "50%", background: color, flexShrink: 0 }),
  cardIcon: { width: "56px", height: "56px", borderRadius: "14px", display: "flex", alignItems: "center", justifyContent: "center" },
  procCard: { background: "#fff", border: "1px solid #d8e0e8", borderRadius: "16px", padding: "32px 24px", boxShadow: "0 4px 20px rgba(10,37,64,.06)" },
  procNum: { fontFamily: "'Playfair Display',serif", fontSize: "52px", fontWeight: 700, color: "#c9a227", lineHeight: 1, marginBottom: "12px", opacity: ".8" },
  procTitle: { fontSize: "16px", fontWeight: 700, color: "#0a2540", marginBottom: "10px" },
  procDesc: { fontSize: "13px", color: "#4a5a6a", lineHeight: 1.7 },
};
